import * as React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/system';
import vector from '../../../../../src/assets/images/Vector.png';
import Ellipse from '../../../../../src/assets/images/Ellipse1.png';

const PreviewContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-end',
  width: '380px',
  height: '160px',
  [theme.breakpoints.down('md')]: {
    alignItems: 'center',
  },
}));
const ImageBox = styled('div')(() => ({
  position: 'relative',
  '& img': {
    width: '150px',
    height: '150px',
    objectFit: 'cover',
    borderRadius: '75px',
  },
}));
const VectorBox = styled('div')(() => ({
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '25px',
  height: '22px',
  right: '6px',
  top: '6px',
  backgroundImage: `url(${Ellipse})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  '& img': {
    width: '11px',
    height: '11px',
  },
}));

export default function AvatarPreview({ images, deleteHandler }) {
  return (
    <PreviewContainer>
      {images ? (
        <ImageBox>
          <img src={images} />
          <VectorBox onClick={() => deleteHandler()}>
            <img src={vector} />
          </VectorBox>
        </ImageBox>
      ) : null}
    </PreviewContainer>
  );
}
